<template>
	<card>
		<template slot="header">
			<h5 v-if="$slots.title || title" class="card-title">
				<slot name="title">
					{{title}}
				</slot>
			</h5>
		</template>
		<div class="loading-spinner" v-if="isLoading">
			<vue-loaders-ball-spin-fade-loader color="white" scale="1.2"/>
		</div>
		<div class="container" v-else>
			<div class="row site-comparison">
				<div class="col-sm-12">
					<h5> Site Comparison:</h5>
				</div>
				<div class="col-sm-12">
					<div class="row">
						<div class="col-xl-3 col-lg-3 selection-site">
							<label class="label-info text-white d-block">Select Sites:</label>
							<multiselect 	v-model="sitename"
														placeholder="Search or add a tag" 
														label="sitename" 
														id="site-select"
														track-by="id" 
														:options="sites" 
														:multiple="true" 
														:taggable="true">
							</multiselect>
						</div>
						<div class="col-lg-3">
							<label class="label-info text-white d-block">Select Period:</label>
							<date-picker
								class="inline-block h-full"
								:attributes ="attrs"
								v-model="pickedDateRange"
								is-range
							>
								<template v-slot="{ inputValue, togglePopover }">
									<div class="flex items-center"  style="display:flex;">
										<button class="timebutton" @click="togglePopover()">
											<svg
												xmlns="http://www.w3.org/2000/svg"
												width="16"
												height="16"
												fill="currentColor"
												class="bi bi-calendar"
												viewBox="0 0 16 16"
											>
												<path
													d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"
												/>
											</svg>
										</button>
										<input
											:value="getValueTime(inputValue)"
											class="display-time"
											readonly
										/>
									</div>
								</template>
							</date-picker>
						</div>
						<div class="col-xl-3 col-lg-3 mb-3 text-left">
							<label class="label-info text-white d-block">Select View Type</label>
							<div style="margin: 0 auto;">
								<div class="switch-info align-items-center text-center">
									<span
										class="view-type pt-2"
										:class="{ 'active-view': viewType == false }"
									>
										Power
									</span>
									<label class="switch">
										<input
											type="checkbox"
											@change="changeView($event)"
											v-model="viewType"
										/>
										<span class="slider"></span>
									</label>
									<span
										class="view-type pt-2"
										:class="{ 'active-view': viewType == true }"
										>Cost</span
									>
								</div>
							</div>
						</div>
						<div class="col-xl-3 col-lg-3">
							<label class="label-info d-block" style="opacity: 0;">Select Speical Period</label>
							<button type="button" class="filter-action" @click="showResult">
								Apply
							</button>
						</div>
					</div>
					<div class="row mb-3 mt-3">
						<div class="col-lg-12" style="padding: 0 30px;">
							<div class="row  info-section">
								<div class="col-xl-6" :class="getClass(index)" v-for="(data, index) in displayData" :key="index">
									<div class="row text-center">
										<div class="col-xl-12">
											<span class="site-title"> {{ names[index] }} </span>
										</div>
									</div>
									<div class="row">
										<div class="col-xl-6">
											<p>Power</p>
											<h3> {{ data.power }} kWh</h3>
										</div>
										<div class="col-xl-6">
											<p>Cost</p>
											<h3>£{{ data.cost }}</h3>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="row supplier-comparison mt-5">
				<div class="col-sm-12">
					<h5> Supplier Comparison:</h5>
				</div>
				<div class="col-sm-12">
					<div class="row" v-if="changedCost.length > 0">
						<div class="col-sm-12 supplier-info">
							<div style="text-align: left;">
								<p> {{user.site}} </p>
								<p>If you were to change supplier you could save:</p>
								<p v-for="cost in changedCost">
									{{ cost.name }}  - {{cost.power}} kWh / £ {{cost.cost }}
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="row mb-4 mt-4">
				<div class="col-lg-12 line-chart">
					<v-chart class="chart" :option="lineOption"/>
				</div>
			</div>
			<div class="row">
				<div class="bar-chart  col-md-6 col-sm-6 col-lg-6">
					<v-chart class="chart" :option="barOption"/>
				</div>
				<div class="bar-chart col-md-6 col-sm-6 col-lg-6">
					<v-chart class="chart" :option="pieOption"/>
				</div>
			</div>
		</div>
	</card>
</template>
<script>

import Card from "./Card.vue";
import { mapActions, mapGetters } from "vuex";
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { BarChart, PieChart} from "echarts/charts";
import {
	TitleComponent,
	TooltipComponent,
	LegendComponent,
	GridComponent
} from "echarts/components";
import VChart  from "vue-echarts";
import QuerySetting from '@/mixins/querySetting';
import OctoberData from '@/mixins/octoberData';

use([
	CanvasRenderer,
	BarChart,
	PieChart,
	TitleComponent,
	TooltipComponent,
	LegendComponent,
	GridComponent
]);


export default {
	name: "comparison-card",
	mixins: [QuerySetting, OctoberData],
	props: {
		title: {
			type: String,
			default: ""
		}
	},
	components: {
		Card,
		VChart
	},
	computed: {
		...mapGetters({
			periodTime: 'settime/getPeriodTime',
			user: 'auth/getUser',
			defaultSiteId: 'auth/getDefaultSiteId'
		}),
	},
	data() {
		return {
			isLoading: true,
			viewType: false,
			sitename: '',
			sites: [],
			rates: [],
			tariff: {
				day: 0,
				night: 0,
				gen: 0
			},
			selectedSupplier: null,
			pickedDateRange: null,
			timeString: '',
			changedCost: [],
			names: ['Brook Green Updated', 'Richard Brown'],
			tempNames: ['Brook Green Updated', 'Richard Brown'],
			displayData:[],
			color: ['#58E2C2', '#F7E53B', '#FF3300', '#3399CC', '#003300'],
			attrs: [
				{
					key: 'today',
    				highlight: true,
					dates: new Date(),
				}
			],
			lineOption: {
				toolbox: {
					show: true,
					orient: "horizontal",
					itemSize: 15,
					itemGap: 10,
					iconStyle: {
						borderColor: "white",
					},
					feature: {
						saveAsImage: {
							show: true,
							title: "Save As Image",
						},
						dataView: {
							show: true,
							title: "Data View",
							optionToContent: function(opt) {
								let series = opt.series;
								let table = '<table style="width:100%;text-align:center;color:black;"><tbody>';

								for (let i = 0; i < series.length; i ++) {
									for (let j = 0; j < series[i].data.length; j ++) {
										table +='<tr><td>' + series[i].data[j][0] + '</td>';
										table +='<td>' + series[i].data[j][1] + '</td>';
										table += '<td>' + series[i].name + '</td></tr>';
									}
								}

								table += '</tbody></table>';
								return table;
							},
						},
						dataZoom: {
							show: true,
							title: {
								zoom: "Area Zoom",
								back: "Restore Area Zoom",
							},
						},
						restore: {
							show: true,
							title: "Restore",
						},
					},
					right: 10,
				},
				tooltip: {
					position: "top",
					axisPointer: {
						type: "shadow",
					},
					backgroundColor: "#484E69",
					borderColor: "#484E69",
					textStyle: {
						color: "white",
					},
				},
				xAxis: {
					type: "time",
					axisLabel: {
						show: true,
						textStyle: {
							color: "white",
							fontSize: "12px",
							fontWeight: 200,
							fontFamily: "Nunito Sans Light",
						},
					},
					splitLine: {
						show: true,
						lineStyle: {
							color: 'rgba(255, 255, 255, 0.3)',
							type: 'solid',
							width: 1
						}
					},
					splitNumber: 8,
					axisTick: {
						show: false,
					},
				},
				yAxis: {
					type: 'value',
					show: true,
					axisLabel: {
						show: true,
						color: 'white',
					},
					splitLine: {
						show: true,
						lineStyle: {
							color: 'rgba(255, 255, 255, 0.3)',
							type: 'dashed',
							width: 1
						}
					},
					splitNumber: 8,
					nameTextStyle: {
						verticalAlign: 'middle',
						color: 'white',
						fontSize: '13px',
						fontFamily: 'Nunito Sans Regular',
						fontWeight: 600,
					}
				},
				grid: {
					width: '100%',
					height: '76%',
					top: 30,
					left: '2%',
					containLabel: true
				},
				legend: {
					bottom: "0",
					data: [],
					borderColor: "#FDFDFD",
					borderWidth: 0.5,
					borderRadius: 5,
					textStyle: {
						color: "#FDFDFD",
					},
					padding: 10,
					icon: "rect",
					itemWidth: 10,
					itemHeight: 10,
					selectedMode: true,
				},
				series: [],
			},
			barOption: {
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'shadow'
					},
					backgroundColor: "#484E69",
					borderColor: "#484E69",
					textStyle: {
						color: 'white'
					}
				},
				legend: {
					itemWidth: 13,
					itemHeight: 13,
					itemGap: 30,
					textStyle: {
						color: 'white',
					},
					borderRadius: 0,
					bottom: 0,
					icon: 'rect'
				},
				grid: {
					width: '100%',
					height: '76%',
					top: 30,
					left: 0,
					containLabel: true
				},
				xAxis: [
					{
						type: 'time',
						axisLabel: {
							show: true,
							textStyle: {
								color: 'white',
								fontSize: '14px',
								fontWeight: 200,
								fontFamily: 'Nunito Sans Light'
							}
						},
						silent: true,
						axisLine: {
							show: true,
							symbol: 'none',
							lineStyle: {
								type: 'dashed'
							}
						},
						axisTick: {
							show: true
						}
					}
				],
				yAxis: [
					{
						type: 'value',
						axisLabel: {
							show: true,
							color: 'white',
							fontSize: '14px',
							fontWeight: 200,
							fontFamily: 'Nunito Sans Light'
						},
						splitLine: {
							lineStyle: {
								color: 'rgba(255, 255, 255, 0.3)',
								type: 'dashed',
								width: 1
							}
						},
					}
				],
				series: []
			},
			pieOption: {
				tooltip: {
					show: true,
					backgroundColor: "#484E69",
					borderColor: "#484E69",
					textStyle: {
						color: 'white'
					},
				},
				legend: {
					itemWidth: 12,
					itemHeight: 12,
					selectedMode: false,
					textStyle: {
						color: 'white',
					},
					icon: 'rect',
					bottom: '0',
				},
				series: [
					{
						type: "pie",
						radius: ['54%', '60%'],
						center: ['50%', '50%'],
						showEmptyCircle: false,
						label: {
							show: false
						},
						labelLine: {
							show: false
						},
						data:[]
					}
				]
			},
		}
	},
	watch: {
		async periodTime(newValue) {
			await this.getTariff(this.user.siteId);
			this.initData();
			this.processData(newValue);
			this.getTimeString();
			this.changedCost = [];
			await this.changeSupplier();
		},
		async defaultSiteId(newValue) {
			await this.getTariff(this.user.siteId);
			this.initData();
			this.processData(this.periodTime);
			await this.changeSupplier();
		}
	},
	async mounted() {
		this.initData();
		this.sites = await this.getCompareSites(this.user.id);
		this.getTimeString();
		await this.getTariff(this.user.siteId);
		await this.changeSupplier();
		this.processData(this.periodTime);
	},
	methods: {
		...mapActions({
			getComparisonData: 'influx/getComparisonData',
			getSites: 'admin/getSites',
			getRates: "admin/getRates",
			getSuppliers: "admin/getSuppliers",
			getSiteData: "influx/getSiteData",
			getCompareSites: 'admin/getCompareSites',
		}),
		getClass(index) {
			if (index === 0) {
				return 'item';
			} else if (index === 1) {
				return 'item1';
			} else {
				if (this.displayData.length % index === 0) {
					return 'item';
				} else {
					return 'item1';
				}
			}
		},
		getTimeString() {
			if (this.periodTime == 'today') this.timeString = 'Day';
			if (this.periodTime == 'month') this.timeString = 'Month';
			if (this.periodTime == 'year') this.timeString = 'Year';
		},
		async getTariff(site) {
			const rates = await this.getRates(site);
			this.tariff = {
				day: rates[rates.length - 1].cost_1,
				night: rates[rates.length - 1].cost_2,
				gen: rates[rates.length - 1].cost_2,
			}

			this.rates = rates;
		},
		async getChangedTariff(site) {
			const rates = await this.getRates(site);
			return  {
				day: rates[rates.length - 1].cost_1,
				night: rates[rates.length - 1].cost_2,
				gen: rates[rates.length - 1].cost_2,
			}
		},
		async processData(value) {
			await this.getCostData(value);
		},
		getSitePowerData(data) {
			let dayPower = data[0];//data[0].concat(data[2]);
			let nightPower = data[1];//data[1].concat(data[3]);

			return [
				dayPower,
				nightPower
			];
		},
		async getHourSeriesData(siteData, index) {
			let data = [];
			let date = new Date().toISOString().slice(0, 10);
			let newDate = new Date(date);
			let count = 0;
			let site = this.sites.find(s => s.sitename == this.names[index]);
			
			if (site) {
				let tariff = await this.getChangedTariff(site.id);

				if (this.viewType) {
					siteData[0].forEach(item => {
						item[1] = item[1] * tariff.day;
					});
					siteData[1].forEach(item => {
						item[1] = item[1] * tariff.night;
					})
				}

				let hourData = siteData[1].concat(siteData[0]);

				for (let i = 0; i < 24; i++) {
					newDate.setHours(i);
					if (!!hourData[i]) {
						data.push([
							newDate.toISOString(),
							Math.round((hourData[i][1] + Number.EPSILON) * 100) / 100
						]);
					} else {
						data.push([newDate.toISOString(), 0]);
					}
				}
			}
			return data;
		},
		async getDaySeriesData(siteData, index) {
			let data = [];
			let date = new Date();
			let firstDay = new Date(date.getFullYear(), date.getMonth(), 2);
			let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 1);
			let count = 0;
			let site = this.sites.find(s => s.sitename == this.names[index]);
			let tariff = await this.getChangedTariff(site.id);

			if (this.viewType) {
				siteData[0].forEach(item => {
					item[1] = item[1] * tariff.day;
				});
				siteData[1].forEach(item => {
					item[1] = item[1] * tariff.night;
				})
			}

			for (let i = firstDay; i <= lastDay; i.setDate(i.getDate() + 1)) {
				if (!!siteData[0][count] && !!siteData[1][count]) {
					data.push([
						new Date(i).toISOString().slice(0, 10),
						Math.round((siteData[0][count][1] + siteData[1][count][1] + Number.EPSILON) * 100) / 100
					]);
				} else {
					data.push([
						new Date(i).toISOString().slice(0, 10),
						0
					]);
				}
				count++;
			}
			return data;
		},
		async getMonthSeriesData(siteData, index) {
			let data = [];
			let date = new Date();
			let site = this.sites.find(s => s.sitename == this.names[index]);
			let tariff = await this.getChangedTariff(site.id);

			if (this.viewType) {
				siteData[0].forEach(item => {
					item[1] = item[1] * tariff.day;
				});
				siteData[1].forEach(item => {
					item[1] = item[1] * tariff.night;
				});
			}

			for (let i = 0; i < 12; i++) {
				let changeDate = new Date(date.getFullYear(), i, 2);
				if (!!siteData[0][i] && !!siteData[1][i]) {
					data.push([
						changeDate.toISOString().slice(0, 10), 
						Math.round((siteData[0][i][1] + siteData[1][i][1] + Number.EPSILON) * 100) / 100
					]);
				} else {
					data.push([
						changeDate.toISOString().slice(0, 10),
						0
					]);
				}
			}
			return data;
		},
		getValueTime(value) {
			if (value.start !== null) {
				return value.start + "-" + value.end;
			} else {
				return "";
			}
		},
		getTotalData(data) {
			let value = 0;
			data.forEach(i => {
				value += i[1]
			});
			return value;
		},
		async getDisplaySitesCompareData(data) {
			this.displayData = [];
			for ( let i = 0; i < data.length; i++) {
				let power = this.getTotalData(data[i][0]) + this.getTotalData(data[i][1]);
				let site = this.sites.find(s => s.sitename == this.names[i]);

				if (site) {
					let tariff = await this.getChangedTariff(site.id);
					data[i][0].forEach(item => {
						item[1] = item[1] * tariff.day;
					});
					data[i][1].forEach(item => {
						item[1] = item[1] * tariff.night;
					});
					let cost = this.getTotalData(data[i][0]) + this.getTotalData(data[i][1]);
					let dataItem = {
						power: Math.abs(Math.round((power + Number.EPSILON) * 100) / 100),
						cost: Math.abs(Math.round((cost + Number.EPSILON) * 100) / 100)
					}
					this.displayData.push(dataItem)
				}
			}
		},
		initData() {
			this.displayData = [];
			this.lineOption.series = [];
			this.barOption.series = [];
			this.pieOption.series[0].data = [];
		},
		async getCostData(value) {
			if (this.sitename.length !== 0) {
				this.names = [];
				this.sitename.forEach(s => {
					this.names.push(s['sitename']);
				})
			}

			let range = [];
			if(!!this.pickedDateRange) {
				let start = this.pickedDateRange.start.toISOString().slice(0,10) + 'T00:00:00Z';
				let end   = this.pickedDateRange.end.toISOString().slice(0,10) + 'T23:59:59Z';
				range = [start, end];
			}
			let siteData = await this.getComparisonData({names:this.names, range:range});
			let powerData = [];
			let barSeriesData = [];
			let pieSeriesData = [];
			let lineSeriesData = [];
			
			siteData.forEach(d => {
				let power = this.getSitePowerData(d);
				powerData.push(power);
			});

			switch(this.periodTime) {
				case 'today':
					for (let i = 0; i < powerData.length; i++) {
						let series = await this.getHourSeriesData(powerData[i], i);
						barSeriesData.push(series);
					}
					break;
				case 'month':
					for (let i = 0; i < powerData.length; i++) {
						let series = await this.getDaySeriesData(powerData[i], i);
						barSeriesData.push(series);
					}
						
					break;
				case 'year':
					for (let i = 0; i < powerData.length; i++) {
						let series = await this.getMonthSeriesData(powerData[i], i);
						barSeriesData.push(series);
					}
						
					break;
			}

			barSeriesData.forEach(site => {
				pieSeriesData.push(this.getTotalData(site));
			});
			
			
			if (!this.viewType) await this.getDisplaySitesCompareData(powerData);

			barSeriesData.forEach((series, i) => {
				this.barOption.series.push({
					name: this.names[i],
					type: 'bar',
					barWidth: '40%',
					itemStyle: {
						opacity: 0.8
					},
					data: series
				});

				this.lineOption.series.push({
					name: this.names[i],
					data: series,
					symbolSize: 0,
					type: 'line'
				});
			});

			this.lineOption.legend.data = this.names;

			if (!this.viewType) {
				this.barOption.tooltip.formatter = (d) => {
					return `${d[0].value[0]} <br/> ${d[0].seriesName} - ${d[0].value[1]}kWh <br/>${d[1].seriesName} - ${d[1].value[1]}kWh`
				}
				this.barOption.yAxis[0].axisLabel.formatter = '{value} kWh';
				this.lineOption.yAxis.axisLabel.formatter = '{value} kWh'
			} else {
				this.barOption.tooltip.formatter = (d) => {
					return `${d[0].value[0]} <br/> ${d[0].seriesName} - £${d[0].value[1]} <br/>${d[1].seriesName} - £${d[1].value[1]}`
				}
				this.barOption.yAxis[0].axisLabel.formatter = ' £{value}';
				this.lineOption.yAxis.axisLabel.formatter = '£{value}'
			}

			pieSeriesData.forEach((series, i) => {
				this.pieOption.series[0].data.push({
					name: this.names[i],
					value: Math.round((series + Number.EPSILON) * 100) / 100
				});
			});

			if (!this.viewType) {
				this.pieOption.tooltip.formatter = (d) => {
					return `${d.name} <br/> ${d.value}kWh`;
				}
			} else {
				this.pieOption.tooltip.formatter = (d) => {
					return `${d.name} <br/> £${d.value}`;
				}
			}
			let colorList = [];
			this.names.forEach((name, i) => {
				colorList.push(this.color[i]);
			});
			this.barOption.color = colorList;
			this.pieOption.color = colorList;
			this.lineOption.color = colorList;
			this.isLoading = false;
		},
		async changeSupplier() {
			let powerData = await this.getSiteData({range:[], site: this.user.site});
			let dayPower = powerData[0];
			let nightPower = powerData[1];
			let totalDay = 0;
			let totalNight = 0;

			dayPower.forEach(item => {
				totalDay += parseFloat(item[1]);
			});
			
			nightPower.forEach(i => {
				totalNight += parseFloat(i[1]);
			});

			let dayCost = 0;
			let nightCost = 0;
			let cost = 0;
			let totalcost = 0;
			let totalPower = 0;
			let currentCost = 0;
			let rates = [];
			let sameSuppliers = [];
			this.rates.forEach(item => {
				let supplier = item.supplier;
				let count = 0;
				for (let index = 0; index < this.rates.length; index++) {
					if (supplier == this.rates[index].supplier) {
						count++;
					}
				}
				if (count > 1) {
					let find = sameSuppliers.find(s=> s == supplier);
					if (!find) 	sameSuppliers.push(supplier);
				 } else {
					rates.push(item);
				 }
			});

			sameSuppliers.forEach(item => {
				let array = this.rates.filter(i => i.supplier == item);
				array.sort((a,b) => { new Date(b.effectDate) - new Date(a.effectDate)});
				let latestItem = array[array.length - 1];
				rates.push(latestItem);
			});

			rates.forEach((item,key)=> {
				dayCost = totalDay * parseFloat(item.cost_1);
				nightCost = totalNight * parseFloat(item.cost_2);
				cost  = dayCost + nightCost;
				currentCost = totalDay * this.tariff.day + totalNight * this.tariff.night;

				if (currentCost > cost) {
					totalcost =  Math.abs(Math.round((cost + Number.EPSILON) * 100) / 100);
					totalPower = Math.abs(Math.round((totalDay + totalNight + Number.EPSILON) * 100) / 100);
					this.changedCost.push(
						{ name: item.supplier, cost: totalcost, power: totalPower}
					);
				}
			});
		},

		changeView() {
			this.processData(this.periodTime)
		},
		showResult() {
			this.initData();
			this.processData(this.periodTime);
		}
	}
};
</script>
<style lang="scss">
.supplier-info {
	background-color: #2b4a62;
    border-radius: 10px;
    padding: 30px;
    text-align: center;
    color: #B4F9A1;
	display: flex;
}
#appliance-select {
	width: 160px;
	height: 30px;
	background-color: #1e365d;
	color: #FFFFFF;
	opacity: 0.9;
	border-color: #fdfdfd;
	border-radius: 4px;
}

.supplier-comparison, .site-comparison {
	border: 1px solid #F2F2F2;
    padding: 20px;
    border-radius: 5px;
}
.line-chart {
	height: 350px;
}

.bar-chart {
	height: 350px;
}
.filter-action {
	width: 160px;
	height: 36px;
	border: 1px	solid #fdfdfd;
	background-color: #1e365d;
	color: white;
	border-radius: 4px;
	z-index: 8;
	&:hover {
		background-color: #1f5881;
	}
}

.switch {
	position: relative;
	display: inline-block;
	width: 40px;
	height: 24px;
}

.switch input {
	opacity: 0;
	width: 0;
	height: 0;
}

.slider {
	position: absolute;
	cursor: pointer;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: #20bfaa;
	-webkit-transition: 0.4s;
	transition: 0.4s;
}
.slider:before {
	position: absolute;
	content: "";
	height: 20px;
	width: 20px;
	left: 2px;
	bottom: 2px;
	background-color: white;
	-webkit-transition: 0.4s;
	transition: 0.4s;
}

input:checked + .slider {
	background-color: #2092bf;
}

input:focus + .slider {
	box-shadow: 0 0 1px #2092bf;
}

input:checked + .slider:before {
	-webkit-transform: translateX(18px);
	-ms-transform: translateX(18px);
	transform: translateX(18px);
}

.display-time {
	width: 200px;
	height: 36px;
	border: 1px solid #fdfdfd;
	background-color: #1e365d;
	border-top-right-radius: 4px;
	border-bottom-right-radius: 4px;
	color: white;
}

.timebutton {
	height: 36px;
	border: 1px solid #fdfdfd;
	background-color: #1e365d;
	color: white;
	border-top-left-radius: 4px;
	border-bottom-left-radius: 4px;
}

.info-section {
	background-color: #2b4a62;
	border-radius: 10px;
	padding: 30px;
	text-align:center;
	color: #B4F9A1;

	.item {
		border-right: 1px solid white;
	}

	.item, .item1 {
		padding: 15px 0;
	}

	.site-title {
		font-size: 20px;
		font-weight: 100;
		font-family: 'Nunito Sans Light';
	}

	h2, h3, h4 {
		margin: 0;
	}

	p {
		margin-bottom: 0;
	}
}
.switch-info {
	margin: 0 auto;
	background-color: #1e365d;
	color: #ffffff;
	opacity: 0.9;
	border-radius: 4px;
	border: 1px solid #fdfdfd;
	padding: 3px;

	.view-type {
		padding: 0 5px;
		text-transform: uppercase;
		font-weight: 100;
		font-family: "Nunito Sans Light";
	}

	.chart-type.active-chart {
		opacity: 1;
	}
}

.multiselect {
	background-color:  #1e365d;
	font-family: 'Nunito Sans Light';

	.multiselect__select {
		background-color:  #1e365d;
		border-radius: 15px;
	}

	.multiselect__tags {
		background-color:  #1e365d;

		#site-select {
			background-color:  #1e365d;
		}
	}

	.multiselect__content {
		background-color:  #1e365d;

		.multiselect__element {
			span {
				color: white;
			}
		}
	}
}

</style>
